import shiftEventsType from './action-types'
import { FetchShiftEventActionPayload } from './types'

export type ShiftEventsAction = ReturnType<typeof fetchShiftEvents>

export const fetchShiftEvents = (payload: FetchShiftEventActionPayload) => ({
  type: shiftEventsType.ENTITIES_FETCH_BEGIN,
  payload,
})
